import type { ReactNode } from "react";
import { IconDots } from "@tabler/icons-react";
import { Button } from "@onengine/component-library";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/core/Drawer";
import styles from "./HeaderOverflowDrawer.module.scss";

interface HeaderOverflowDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tone?: "danger" | "notice";
  children: ReactNode;
}

export function HeaderOverflowSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {children}
    </section>
  );
}

export function HeaderOverflowDrawer({
  open,
  onOpenChange,
  tone,
  children,
}: HeaderOverflowDrawerProps) {
  return (
    <>
      <span className={styles.trigger}>
        <Button
          type="icon"
          variant="tertiary"
          size="small"
          iconLeft={<IconDots size={18} />}
          onClick={() => onOpenChange(true)}
          htmlAttributes={{ "aria-label": "More actions", "aria-haspopup": "dialog" }}
        />
        {tone && <span className={styles.dot} data-tone={tone} aria-hidden />}
      </span>
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className={styles.drawer}>
          <DrawerHeader>
            <DrawerTitle>More actions</DrawerTitle>
            <DrawerClose />
          </DrawerHeader>
          <DrawerBody>
            <div className={styles.actions}>{children}</div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
